import PropTypes from 'prop-types';

const faqUnreleasedImageryPayloadType = PropTypes.shape({
  faqUnreleasedImageryHtml: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  faqUnreleasedImagery: PropTypes.object,
  editorialLicenseFormUrl: PropTypes.string,
});

export default faqUnreleasedImageryPayloadType;
